module.exports = __webpack_public_path__ + "static/media/github-logo.85a49480.png";